import React from 'react'

import { useTranslation } from 'language/translator'
import { TDashboardWidget } from 'types/GlobalWidget'

import Box from 'components_new/atoms/Box'

import ErrorPlaceholder from 'components_new/molecules/ErrorPlaceholder'
import LoadingSection from 'components_new/molecules/LoadingSection'

import Widget from 'components_new/organisms/Widget'
import { DashboardVariantType } from 'types/GlobalDashboard'

import { useWidgetLoadingTitles } from 'utils/loadingTitles'

interface PublicWidgetTemplateProps {
  error: boolean
  loadingBGC?: string
  widget: TDashboardWidget | null
  variantType: DashboardVariantType
}

const PublicWidgetTemplate = (props: PublicWidgetTemplateProps) => {
  const { error, loadingBGC, widget, variantType } = props
  const { t } = useTranslation()
  const loadingTitles = useWidgetLoadingTitles()

  if (error) {
    return (
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <ErrorPlaceholder
          code={401}
          body={t('dashboards', 'error_public_widget_body')}
        />
      </Box>
    )
  }

  if (!widget) {
    return (
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          bgcolor: loadingBGC
        }}
      >
        <LoadingSection description={loadingTitles} />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        bgcolor: widget.customization?.background_colors?.paper
      }}
    >
      <Widget
        availableSpace={null}
        customization={widget.customization}
        dashboardFilter={[]}
        dashboardFilterOptions={new Map()}
        interactive={false}
        fetchWidgetData={() => {}}
        editMode={false}
        embedded={true}
        variantType={variantType}
        isAdmin={false}
        plain={true}
        resetAllDashboardTempStates={() => {}}
        scaleFactor={1}
        standaloneWidget={true}
        widget={widget}
      />
    </Box>
  )
}

export default PublicWidgetTemplate
